export const ACTION = {
  UPDATE_APP_STATE: 'UPDATE_APP_STATE',
  CLEAR_APP_STATE: 'CLEAR_APP_STATE',
  UPDATE_TEAM_STATE: 'UPDATE_TEAM_STATE',
  CLEAR_TEAM_STATE: 'CLEAR_TEAM_STATE',
};
